// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonObjects = {
  baseImage: "KVM System Image",
  containerImage: "Container Image",
  customImage: "Custom Image",
  applicationImage: "Application Image",
  dynamipsIosImage: "Dynamips IOS Image",
  physicalDevice: "Physical Device",
  spec: "Spec",
  topologyTemplate: "Topology Template",
  topologyVersion: "Topology Version",
  executionSnapshot: "Execution Snapshot",
  topologyViewSnapshot: "Topology View Snapshot",
  containerSpec: "Container Spec",
  vmSpec: "VM Spec",
  simulatorModel: "Simulator Model",
  loginCredential: "Login Credential",
  accessPort: "Access Port",
  imagePortServiceProtocol: "Port Service Protocol",
  applicationParameter: "Application Parameter",
  applicationAction: "Application Action",
  actionInputParameter: "Action Input Parameter",
  outputItem: "Output Item",
} as const;
